import { render, staticRenderFns } from "./BuyerAcceptanceDialog.vue?vue&type=template&id=660b1c64&"
import script from "./BuyerAcceptanceDialog.vue?vue&type=script&lang=js&"
export * from "./BuyerAcceptanceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports